import React from 'react';

const Bar = ({ className = '' }) => (
  <div className={`animate-pulse rounded bg-slate-200 ${className}`} />
);

/**
 * First-load placeholder. Mirrors the real layout on both breakpoints so the
 * page does not jump when the data lands.
 *
 * NOTE on visibility classes: `src/Styles.scss` declares
 * `.hidden { display: none !important }`, which beats `md:block`. Desktop-only
 * blocks therefore use `max-md:hidden`, never `hidden md:block`.
 */
const ListSkeleton = ({ rows = 6 }) => {
  const items = Array.from({ length: rows });

  return (
    <>
      {/* Desktop table skeleton */}
      <div className="max-md:hidden overflow-hidden rounded-xl border border-slate-200 bg-white">
        <div className="flex items-center gap-4 border-b border-slate-200 bg-slate-50 px-4 py-3">
          <Bar className="h-3 w-40" />
          <Bar className="h-3 w-28" />
          <Bar className="h-3 w-24" />
          <Bar className="h-3 w-32" />
        </div>
        {items.map((_, i) => (
          <div key={i} className="flex items-center gap-4 border-b border-slate-100 px-4 py-3 last:border-b-0">
            <Bar className="h-11 w-11 shrink-0 rounded-lg" />
            <div className="flex-1 space-y-2">
              <Bar className="h-3 w-1/3" />
              <Bar className="h-2.5 w-1/5" />
            </div>
            <Bar className="h-5 w-24 rounded-full" />
            <Bar className="h-3 w-20" />
            <Bar className="h-3 w-16" />
            <Bar className="h-8 w-20 rounded-lg" />
          </div>
        ))}
      </div>

      {/* Mobile card skeleton */}
      <div className="md:hidden space-y-3">
        {items.slice(0, 4).map((_, i) => (
          <div key={i} className="rounded-xl border border-slate-200 bg-white p-3">
            <div className="flex gap-3">
              <Bar className="h-16 w-16 shrink-0 rounded-lg" />
              <div className="flex-1 space-y-2">
                <Bar className="h-3 w-2/3" />
                <Bar className="h-2.5 w-1/3" />
                <Bar className="h-5 w-24 rounded-full" />
              </div>
            </div>
            <Bar className="mt-3 h-3 w-1/2" />
          </div>
        ))}
      </div>
    </>
  );
};

export default ListSkeleton;
